import client from "../client";

export interface NotifyWithdrawCreditRequest {
  bank_member_id: number; // The ID of the bank member requesting the withdrawal
  amount: number; // The amount to withdraw, must be greater than 0 and less than or equal to 49999
  notes?: string; // Optional notes for the withdrawal request
  ip_address?: string; // Optional IP address of the user making the request
}

export interface NotifyWithdrawCreditResponse {
  success?: boolean; // Indicates if the withdrawal request was successful
  message?: string; // Message providing additional information about the request
  reference_id?: string; // Unique reference ID for the withdrawal request
  transaction_id?: number; // ID of the transaction created for the withdrawal
  status?: string; // Current status of the withdrawal request
  amount?: number; // Amount requested for withdrawal
  fee?: number; // Fee charged for the withdrawal
  net_amount?: number; // Net amount after deducting fees
  balance_before?: number; // Balance before the withdrawal
  balance_after?: number; // Balance after the withdrawal
  created_at?: string; // Timestamp when the withdrawal request was created
}

export default function API(
  request: NotifyWithdrawCreditRequest
): Promise<NotifyWithdrawCreditResponse> {
  return client
    .post(`payment_v2/withdraw/notify`, request)
    .then((response) => response.data);
}
